export default __webpack_public_path__ + "betslip-icon.png";